var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"bravado-logo",attrs:{"src":require('./logo.svg'),"alt":"Bravado","width":"122","height":"21"}})}
var staticRenderFns = []

export { render, staticRenderFns }